import * as ArrayUtils from './array';
import * as ConversionUtils from './conversion';
import AdiMath from './math';

export function getRangeLimits(graphData) {
  var model = graphData;
  var minx = Math.min(...model.map((x) => x[0]));
  var maxx = Math.max(...model.map((x) => x[0]));
  var miny = null;
  var maxy = null;
  if (graphData.length > 0 && graphData[0].length === 2) {
    miny = Math.min(...model.map((x) => x[1]));
    maxy = Math.max(...model.map((x) => x[1]));
  } else {
    var yValues = [];
    model.forEach((x) => {
      yValues.push(x[1]);
      yValues.push(x[2]);
      yValues.push(x[3]);
    });
    miny = Math.min(...yValues);
    maxy = Math.max(...yValues);
  }

  var result = { xmin: minx, xmax: maxx, ymin: miny, ymax: maxy };
  return result;
}

export function getGraphData(stage) {
  var magnitude = stage.magnitude;
  var frequencyArray = stage.frequencyArray;
  var dbData = ConversionUtils.VVarrtoDBarr(magnitude);
  var dataPoints = ArrayUtils.joinArrays(frequencyArray, dbData);
  var limits = this.getRangeLimits(dataPoints);
  var result = { data: dataPoints, limits: limits };
  return result;
}

// magnitude util
export function getMagnitudeArray(individualStageArray) {
  var groupedByIndex = ArrayUtils.groupByIndex(individualStageArray);
  var result = groupedByIndex.map((item) => {
    var product = 1;
    for (var i = 0; i < item.length; i++) {
      product *= item[i];
    }

    return product;
  });

  return result;
}

// Phase util
export function getPhaseArray(individualStageArray) {
  var groupedByIndex = ArrayUtils.groupByIndex(individualStageArray);
  var summedByIndex = groupedByIndex.map((item) => {
    var sum = 0;
    for (var i = 0; i < item.length; i++) {
      sum += item[i];
    }

    return sum;
  });

  var result = summedByIndex;
  return result;
}

// phase util
export function unwrapPhase(phaseArray) {
  var halfcircle = Math.PI,
    fullcircle = 2 * Math.PI;

  var length = phaseArray.length;
  for (var n = 1; n <= length - 1; n++) {
    var phase_diff = phaseArray[n] - phaseArray[n - 1];
    if (phase_diff > halfcircle) {
      for (var k = n; k <= length - 1; k++) {
        phaseArray[k] = phaseArray[k] - fullcircle;
      }
    }
    if (phase_diff < -halfcircle) {
      for (var j = n; j <= length - 1; j++) {
        phaseArray[j] = phaseArray[j] + fullcircle;
      }
    }
  }

  return phaseArray;
}

// step response util
export function computeFirstOrderStepResponseIdeal(timePoint, stepResponseSetup) {
  var tw0 = -1 * timePoint * stepResponseSetup.w0;
  var result = stepResponseSetup.a - stepResponseSetup.b * Math.exp(tw0);
  return result;
}

// step response util
export function computeSecondOrderStepResponseIdeal(timePoint, stepResponseSetup) {
  var a = stepResponseSetup.a;
  var b = stepResponseSetup.b;
  var c = stepResponseSetup.c;
  var w0 = stepResponseSetup.w0;
  var Q = stepResponseSetup.Q;

  var X = -c - a * w0 * w0 + 2 * b * w0 * Q; //X=-c-a*wo**2+2*b*wo*Q;
  var Y = -(w0 * w0) * (-1 + 4 * Q * Q); //Y=-wo**2*(-1 + 4*Q**2);
  var W = a * w0 * w0 - c; //W=a*wo**2-c;
  var Z = Math.exp((-timePoint * w0) / 2 / Q); //Z=exp(-t*wo/2/Q);
  var sqrtY = Math.sqrt(Y); //sqrt(Y)
  var tYQ = (timePoint * sqrtY) / 2 / Q; //t*sqrt(Y)/2/Q
  var sinhY = AdiMath.sinh(tYQ); //sinh(t*sqrt(Y)/2/Q)
  var coshY = AdiMath.cosh(tYQ); //cosh(t*sqrt(Y)/2/Q)
  var sqrtNegY = Math.sqrt(-Y); //sqrt(-Y)
  var w02 = w0 * w0; //w0**2
  var w03 = w02 * w0; //w0**3
  var exptw0 = Math.exp(timePoint * w0); // exp(t*wo)
  var answer = null;
  if (Y > 0) {
    answer = (X * sinhY * Z) / sqrtY / w0 + (c + W * coshY * Z) / (w0 * w0);
  }
  if (Y < 0) {
    answer =
      (X * Math.sin((timePoint * sqrtNegY) / 2 / Q) * Z) / sqrtNegY / w0 +
      (c + W * Math.cos((timePoint * sqrtNegY) / 2 / Q) * Z) / (w0 * w0);
  }
  if (Y === 0) {
    answer =
      -(c - c * exptw0 - a * w02 + a * timePoint * w03 - b * timePoint * w02 + c * timePoint * w0) / (w02 * exptw0);
  }

  return answer;
}
